<template>
	<div :class="$style.wrapper">
		<div
			:class="$style.active"
			:style="{
				width: getActiveBarPercentage,
				background: getActiveBarColor,
			}"
		/>
		<div
			:class="$style.limit"
			:style="{ left: getLeftShiftPercentage }"
		/>
	</div>
</template>

<script>
export default {
	name: 'PassportLimitProgressBar',
	props: {
		total: Number,
		current: Number,
		limit: Number,
	},
	computed: {
		getActiveBarPercentage() {
			return (this.current / this.total) * 100 + '%'
		},
		getLeftShiftPercentage() {
			return (this.limit / this.total) * 100 + '%'
		},
		getActiveBarColor() {
			const fault = this.limit - this.current
			if (fault < 5 && fault > -5) {
				return '#27AE60'
			}
			if (fault < 0) {
				return '#F97272'
			}

			return '#F2C94C'
		},
	},
	methods: {},
}
</script>

<style module lang="scss">
.wrapper {
	position: relative;
	width: 100%;
	height: 8px;
	background: #e0e0e0;
	border-radius: 2px;
}

.active {
	border-radius: 2px 0 0 2px;
	position: absolute;
	height: 8px;
}

.limit {
	width: 1px;
	height: 8px;
	background: black;
	position: absolute;
	left: 50%;
}
</style>
